export const formatPrice = (price) => {
  price = isNaN(price) ? 0 : price;

  return `$${Number(price).toLocaleString('en-MX', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};
